import { render, staticRenderFns } from "./SlotsModal.vue?vue&type=template&id=948d7d5c&scoped=true"
import script from "./SlotsModal.vue?vue&type=script&lang=js"
export * from "./SlotsModal.vue?vue&type=script&lang=js"
import style0 from "./SlotsModal.vue?vue&type=style&index=0&id=948d7d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948d7d5c",
  null
  
)

export default component.exports